module.exports = __webpack_public_path__ + "img/BTX.38b1db71.svg";